<div>
	<div>
		@if (dynamicArea == "lines") {
			<div class="d-flex gap-2 justify-content-between align-items-start">
				<div>
					<h1 style="font-weight: bold">
						{{ dataObj?.title }} {{ dataObj?.name }}
					</h1>

					@if (dataObj?.occupation) {
						<div class="details-list">
							<div icon="profession"></div>
							<div>{{ dataObj?.occupation }}</div>
						</div>
					}
					@if (dataObj?.phone) {
						<div class="details-list">
							<div icon="phone"></div>
							<div>{{ dataObj?.phone }}</div>
						</div>
					}
					@if (dataObj?.email) {
						<div class="details-list">
							<div icon="email"></div>
							<div>{{ dataObj?.email }}</div>
						</div>
					}
					@if (dataObj?.website) {
						<div class="details-list">
							<div icon="link-grey"></div>
							<div>
								<a
									[href]="$safeNavigationMigration(dataObj?.website)"
									target="_blank"
									>{{ dataObj?.website }}</a
								>
							</div>
						</div>
					}
				</div>
				@if (dataObj?.image) {
					<div class="mis-auto">
						<img
							[src]="
								dataObj?.image
									? environment.serverUrl +
										'/user-image?fdsewrfsdfds=' +
										fdsewrfsdfds +
										'&hgfe5ty6hjtgft454tr=' +
										hgfe5ty6hjtgft454tr
									: '/assets/images/missing_avatar.gif'
							"
							[alt]="
								$safeNavigationMigration(dataObj?.name) +
								' ' +
								$safeNavigationMigration(dataObj?.title)
							"
							style="width: 150px; height: 150px; border-radius: 50%"
							class="pb-2"
						/>
					</div>
				}
			</div>

			<div class="d-flex flex-column gap-1">
				@if (dataObj?.phone) {
					<div class="mis-auto">
						<button class="btn btn-primary home-button">
							<!-- remember for merge  -->
							<a
								[href]="
									'https://whatsapp.com/' +
									$safeNavigationMigration(dataObj?.phone)
								"
								style="color: white"
								target="_blank"
								postIcon="leftArrow"
								>{{ "whatsapp" | langVal }}
							</a>
							<!-- remember for merge  -->
						</button>
					</div>
				}
				@if (eventsService.isMobile) {
					@if (dataObj?.meeting_request_with_calendar) {
						<div class="mis-auto">
							<button
								class="btn btn-primary home-button"
								(click)="setMeetingClick()"
								postIcon="leftArrow"
							>
								{{ "to_meeting_request" | langVal }}
								<!--{{dataObj?.name}}-->
							</button>
						</div>
					}
					<div class="mis-auto">
						<button
							class="btn btn-primary home-button"
							(click)="goToForm()"
							postIcon="leftArrow"
						>
							{{ "to_meeting-request_no_calendar_with" | langVal }}
							<!--{{dataObj?.name}}-->
						</button>
					</div>
				}
			</div>

			<div
				[hidden]="dynamicArea != 'lines' || !dataObj?.userdetail_lines"
				class="mt-3 pt-3 d-grid gap-4"
				style="border-top: 1px solid var(--green)"
			>
				@if (dataObj?.expertise) {
					<div class="details-text">
						<h2>{{ "expertise" | langVal }}</h2>
						<p>{{ dataObj?.expertise }}</p>
					</div>
				}
				@if (dataObj?.languages) {
					<div class="details-text">
						<h2>{{ "languages" | langVal }}</h2>
						<p>{{ dataObj?.languages }}</p>
					</div>
				}
				@if (dataObj?.address) {
					<div class="details-text">
						<h2>{{ "address" | langVal }}</h2>
						<p>{{ dataObj?.address }}</p>
					</div>
				}
				@for (
					userdetail_line of dataObj?.userdetail_lines;
					track userdetail_line
				) {
					<div class="details-text">
						<h2>{{ userdetail_line.subject_web }}</h2>
						<p [innerHTML]="userdetail_line.description_web | safeHtml"></p>
					</div>
				}
			</div>
		}
	</div>
	<div [hidden]="dynamicArea != 'hours'">
		<app-guest-hours-sched
			#hoursComp
			(chosenHourOut)="backFromHours($event); scrollToTop()"
			(backEv)="dynamicArea = 'lines'; scrollToTop()"
			[dataObj]="dataObj"
		></app-guest-hours-sched>
	</div>
	<div [hidden]="dynamicArea != 'form'">
		<app-guest-add-meeting-form
			#formComp
			[saveObj]="saveObj"
			[dataObj]="dataObj"
			(backEv)="backFromForm($event); scrollToTop()"
		></app-guest-add-meeting-form>
	</div>
</div>
